import ApiModule from './index'
import BaseModel from '../../base/BaseModel'

export class ExchangeCouponApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.MARKETACTIVITIES
		this.url = '/redeemActivity/writeOffRedeemCode'
		this.desc = '兑换券码'
	}
}
